import React, { Component } from "react";
import ParallaxSection from "../components/general/parallaxSection/parallaxSection.jsx";

class about extends Component {
  state = {};
  render() {
    return (
      <React.Fragment>
        <ParallaxSection />
      </React.Fragment>
    );
  }
}

export default about;
